/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { Helmet } from 'react-helmet';

export const OneTrustCookieBanner = (): JSX.Element => (
  <Helmet>
    <script
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      data-document-language="true"
      type="text/javascript"
      data-domain-script={process.env.GATSBY_ROCHE_ONETRUST_KEY}
      // eslint-disable-next-line react/no-unknown-property
      charset="UTF-8" />
  </Helmet>
);
